module.exports = __webpack_public_path__ + "static/img/project.b03f74a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project.png
// module id = 430
// module chunks = 1